import http from '../../../../utils/httpService';

import {
    PRIZES_ROUTE
} from './constants';

/**
 *
 * @param calendarID
 */
const requestPrizeCreation = calendarID => {
    return http.request( PRIZES_ROUTE, 'POST', { calendar_id: calendarID } );
};
/**
 *
 * @param prizeID
 * @param updateObj
 */
const requestPrizeUpdate = ( prizeID, updateObj ) => {
    return http.request( PRIZES_ROUTE + `/${ prizeID }`, 'PUT', updateObj );
};
/**
 *
 * @param prizeID
 */
const requestPrizeDelete = prizeID => {
    return http.request( PRIZES_ROUTE + `/${ prizeID }`, 'DELETE' );
};

export {
    requestPrizeCreation,
    requestPrizeDelete,
    requestPrizeUpdate
};
